export default __webpack_public_path__ + "static/media/Skullkin Seed.e378c255.PNG";